export const STATE_PENDING = 'pending'
export const STATE_VERIFIED = 'verified'
export const STATE_DISABLED = 'disabled'
